import React from 'react'
import { Box } from '@mui/material';
import { RobotoTypo, TimesNewTypo } from '../../../utils/Typographies';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Circle } from '../../../assets/ServicesImages/StudentPassApplicationImages/circle.svg';
import Arrow from '../../../assets/Home/ApplicationProcess/ApplicationProcessArrow.svg';
import Arrowline from '../StudentPassApplication/Arrowline';
import Arrowline2 from '../StudentPassApplication/Arrowline2';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    // Media query for screens narrower than 1024px
    '@media (max-width: 1200px)': {
        firstRow: {
            flexDirection: 'column',
            gap: '40px'
        },
        arrowImg: {
            marginBottom: '25px',
            transform: 'rotate(90deg)',
        }
    },
}));
export default function StudentApplicationProcess() {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <Box sx={{ position: 'relative', background: '#F7F7F7' }}>
            
           <br />
            <br />
            <Box sx={{ display: 'flex', gap: '60px', flexDirection: 'column', justifyContent: 'center', margin: '0 3%', mt : 4, mb :4 }}>
                <Box sx={{ alignSelf: 'center', backgroundColor: '#003B5C', padding: '8px 24px', borderRadius: '50px', width: 'fit-content' }}>
                    <RobotoTypo sx={{ fontWeight: '700', fontSize: { xs: '18px', sm: '21px', md: '24px' }, minWidth: '150px', color: '#FFFFFF', letterSpacing: '0.02em', textAlign: 'center' }}>
                        {t('service.InternationalCompetition.instruction', { returnObjects: true }).title}
                    </RobotoTypo>
                </Box>
                <Box sx={{ width: { xs: '70%', lg: '50%' }, backgroundColor: "#FFFFFF", borderRadius: '50px', display: 'flex', flexDirection: 'column', margin: '0 auto', gap: '10px', padding: '20px' }}>
                    {t('service.InternationalCompetition.instruction.bullets', { returnObjects: true }).map((item, index) => (
                        <Box key={index} sx={{ margin: '10px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                            <Box

                            ></Box>
                            <RobotoTypo sx={{ fontWeight: '400', letterSpacing: '0.03em', lineHeight: '28px', color: '#242424', fontSize: { xs: '16px', md: '16px', lg: '16px' }, textAlign: 'left' }}>
                            {`${index+1}.) ${item}`}
                            </RobotoTypo>

                        </Box>
                    ))}
                </Box>
            </Box> <br /><br />



        </Box>
    )
}
